import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { DeleteOutlined as DeleteOutlinedIcon } from '@mui/icons-material/'

import React, { useState } from 'react'
import { adminTeamsService } from '../../../services/admin/teams'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { toast } from 'react-toastify'

const TeamUserCard = ({ team, teamUserIds, users = [] }) => {
  const { user } = useAuthContext()
  const [selectedUserIds, setSelectedUserIds] = useState([...teamUserIds])
  const [newlySelectedUserIds, setNewlySelectedUserIds] = useState([])

  const delUserTeamMap = async (userId, teamId) => {
    try {
      await adminTeamsService.deleteUserFromTeam(user, userId, teamId)
      setSelectedUserIds((items) => items.filter((it) => it != userId))
      toast.success('User removed from team successfully!')
    } catch (error) {
      toast.error(error.message)
    }
  }

  const addUserTeamMap = async () => {
    try {
      await adminTeamsService.addUserToTeam(user, newlySelectedUserIds, team.id)
      setSelectedUserIds([...selectedUserIds, ...newlySelectedUserIds])
      setNewlySelectedUserIds([])
      toast.success('User(s) added to team successfully!')
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  return (
    <Card elevation={1}>
      <CardHeader
        title={team.name}
        subheader={
          <Autocomplete
            multiple
            style={{ marginTop: 16 }}
            value={users.filter((it) => newlySelectedUserIds.includes(it.id)) || []}
            size="small"
            options={users.filter((it) => !selectedUserIds.includes(it.id))}
            getOptionLabel={(it) => it.first_name + ' ' + it.last_name + ' (' + it.email + ')'}
            renderInput={(params) => <TextField {...params} label="Select User(s)" />}
            onChange={(_, v) => setNewlySelectedUserIds(v?.map((it) => it.id) || [])}
          />
        }
      />

      {newlySelectedUserIds.length > 0 && (
        <Button
          style={{ margin: '0px 16px' }}
          color="primary"
          variant="contained"
          type="button"
          size="small"
          onClick={addUserTeamMap}
        >
          Save
        </Button>
      )}
      <CardContent style={{ margin: '0px 0px' }} key={team.id}>
        {/* render all users associated with team */}
        {users
          .filter((u) => selectedUserIds.includes(u.id))
          .map((u) => (
            <Typography
              key={team.id + '/' + u.id}
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: 16 }}
            >
              <Tooltip title={'Remove user from team'}>
                <IconButton
                  id={`del_${u.id}_${team.id}`}
                  name={`del_${u.id}_${team.id}`}
                  onClick={(e) => delUserTeamMap(u.id, team.id)}
                  size="small"
                >
                  <DeleteOutlinedIcon color="primary" />
                </IconButton>
              </Tooltip>
              {`${u.first_name} ${u.last_name} (${u.email})`}
            </Typography>
          ))}
      </CardContent>
    </Card>
  )
}

export default TeamUserCard
